import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../Utility/Utility";

function Items() {
  var OBJ: OggettoConfig = {
    Id: "items",
    RestRoute:'/prodotti',
    Headers:[
      CampoAggiuntivo.TextField("Id", "item_id",'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("Descrizione", "item_name",'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("Unità di misura", "measure_unit",'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("Quantità", "quantity",'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("Stock", "stock_id",'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("Store", "store_id",'col-12', {modificabile:false})
    ],
    Filters:[
      CampoAggiuntivo.TextField("IP", 'ip'),
      CampoAggiuntivo.InputField("Porta", 'port','numeric'),
      CampoAggiuntivo.TextField("Cod. Articolo", 'item_id')
    ],
    asyncFullResponseMap: async (response: any | any[], component?: DynamicListComponent, callBack?: (response)=>any)=>{
      var storedIP = GetFromLocalStorage('icam_ip');
      var storedPort = GetFromLocalStorage('icam_port');
      if(!component.filtro.ip && !component.filtro.port){
        component.filtro.ip = storedIP;
        component.filtro.port = storedPort;
      }
      if(!component.filtro.ip || !component.filtro.port){
        callBack([]);
        return;
      }

      var inventario = await component.api.Icam.exportDetailedInventory(component.filtro.ip,component.filtro.port);
      console.log('inventario', inventario);
      callBack(inventario.filter((x)=>!component.filtro.item_id || x.item_id?.toLowerCase().includes(component.filtro.item_id.toLowerCase())));
      SaveToLocalStorage('icam_ip', component.filtro.ip);
      SaveToLocalStorage('icam_port', component.filtro.port);
    },
    MenuItems: [
      {
        path: "shared/dynamiclist/items",
        title: "Inventario ICAM",
        icon: "far fa-copy",
      }
    ]
  }
  return OBJ;
}


export var ItemsEnv = () => {
  var env: any = {
    Modules: {
      "Items": true
    },
    Cruds: [Items()],
    Menu: [...Items().MenuItems]
  }
  return env;

}
